var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 55,
    viewBox: "0 0 90 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.7935 1H1L1.07328 54.0491L88.7069 54.1957L89 51.1915L88.2673 47.3813L86.3622 42.3988L86.6553 37.7827L85.8493 36.2439L85.776 26.2789L82.0391 16.1673L81.5995 8.9134L82.6986 6.42214L80.7935 1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNd);
export default __webpack_public_path__ + "static/media/ND.536cab1ebf526ff78f17a8bd450ea0f7.svg";
export { ForwardRef as ReactComponent };